import { render, staticRenderFns } from "./AddCustomerServices.vue?vue&type=template&id=aea20510&scoped=true&"
import script from "./AddCustomerServices.vue?vue&type=script&lang=js&"
export * from "./AddCustomerServices.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerServices.vue?vue&type=style&index=0&id=aea20510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea20510",
  null
  
)

export default component.exports